<script>
import {bloquearParaLeilao, checarInformacoesBloqueioGrv} from '../../../../domain/grv/services'
import {isArray} from 'lodash'

export default {
  name: 'BloquearGrvLeilaoAlerta',
  props: {
    grvId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      atualizadoSucesso: false,
      cadastroError: null,
      isLoaded: false,
      data: {lotes: []},
      motivoBloqueio: null
    }
  },
  computed: {
    impedirBloqueio () {
      return false
      // const {lotes, transmitido} = this.data
      // return lotes.length || transmitido.length // || retirado
    },
    isSemMotivo () {
      return !(this.motivoBloqueio || '').length
    },
    hasParentLoading () {
      return this.$parent && typeof this.$parent.loading === 'function'
    },
    isBloqueado () {
      return this.data.bloqueado
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.setParentLoading(true)
      checarInformacoesBloqueioGrv(this.grvId)
        .then(result => {
          this.data = result.data
          this.motivoBloqueio = this.data.motivo
          console.log(result.data)
        })
        .catch(error => {
          alert('Erro ao carregar as informações de exclusão')
          console.log(error)
        })
        .finally(() => {
          this.isLoaded = true
          this.setParentLoading(false)
        })
    },
    bloquearGrvParaLeilao () {
      const acao = this.isBloqueado ? 'desbloqueio' : 'bloqueio'
      if (this.isSemMotivo) return alert(`Explique o motivo para o ${acao} desta GRV.`)
      const confirmar = confirm(`Confirmar ${acao}?`)
      if (!confirmar) return
      this.setParentLoading(true)
      if (this.isBloqueado) {
        this.motivoBloqueio = null
      }
      bloquearParaLeilao(this.grvId, !this.isBloqueado, this.motivoBloqueio)
          .then(result => {
            this.$emit('finishSubmit')
            this.atualizadoSucesso = true
          })
          .catch(error => {
            alert('Erro ao efetuar operação')
            console.log(error)
            this.cadastroError = error.data.errors
          })
        .finally(() => {
          this.setParentLoading(false)
        })
    },
    setParentLoading (option) {
      this.hasParentLoading && this.$parent.loading(option)
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded && !atualizadoSucesso" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-12"><h1 class="m-n font-thin h3">Bloqueio de GRV para leilão</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao bloquear GRV</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">Excluído com sucesso!</div>
            </div>

            <h4>Atenção!</h4>
            <small v-if="isBloqueado">A GRV foi bloqueada para leilões em {{data.dataBloqueio.date|formatDate('DD/MM/YYYY HH:mm')}} pelo seguinte motivo:
              <br><br>
              {{motivoBloqueio}}
            </small>
            <small v-else>A GRV selecionada não poderá ser utilizada para criação de lote.</small>

            <hr v-if="data.lotes.length">

            <h4 class="m-b-lg" v-if="data.lotes.length"><i class="fa fa-exclamation-triangle text-danger"></i> Esta GRV está ligada aos seguintes leilões:</h4>
            <div class="row" v-if="data.lotes.length">
              <div class="col-sm-12">
                <ul class="list-unstyled l-h-2x">
                  <li v-for="lote in data.lotes">Lote <strong>{{lote.lote}}</strong> no leilão <strong>{{lote.tituloLeilao}}</strong></li>
                </ul>
              </div>
            </div>

            <hr v-if="!isBloqueado">

            <div class="row" v-if="!impedirBloqueio && !isBloqueado">
              <div class="col-sm-12">
                <div class="">
                  <textarea class="form-control" rows="4" v-model.trim="motivoBloqueio" placeholder="Motivo do bloqueio" style="max-height: 50px"/>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
            <hr>
            <div class="row wrapper" v-if="!impedirBloqueio">
              <u-button class="btn m-b-xs w-auto btn-danger m-r-xs" @click="bloquearGrvParaLeilao" :disabled="isSemMotivo">
                <span v-if="isBloqueado">Desbloquear</span>
                <span v-else>Confirmar bloqueio</span>
              </u-button>
              <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('cancel')">Cancelar</u-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-transition" v-else-if="atualizadoSucesso">
      <div class="wrapper-md">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <i class="fa fa-check-circle fa-5x text-success"></i>
          <h4 class="m-t-lg">Grv bloqueada com sucesso!</h4>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .lista-efeitos-colaterais li::before {
    content: '=> ';
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// BloquearGrvLeilaoAlerta.vue?2275b091